import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CalendarClock } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const LETTERS = 'ABCDEFGHJKL'.split('');
const GR_SHOWS = [
  { id: '11am', label: '11 AM' },
  { id: '12pm', label: '12 PM' },
  { id: '5pm', label: '5 PM' },
  { id: '7pm', label: '7 PM' },
];
const istYesterday = () =>
  new Date(Date.now() + 5.5 * 3600000 - 86400000).toISOString().slice(0, 10);

const empty = () =>
  Object.fromEntries(GR_SHOWS.map((s) => [s.id, { letter: '', digits: '' }]));

export function GRBackdateControl({ authHeaders }) {
  const [date, setDate] = useState(istYesterday());
  const [rows, setRows] = useState(empty());
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setRows(empty());
    axios
      .get(`${API}/api/results`, { headers: authHeaders() })
      .then((r) => {
        const next = empty();
        r.data
          .filter((x) => x.date === date)
          .forEach((x) => {
            next[x.show] = { letter: x.letter || '', digits: x.digits || '' };
          });
        setRows(next);
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  const set = (id, field, val) =>
    setRows((r) => ({ ...r, [id]: { ...r[id], [field]: val } }));

  const save = async () => {
    const items = GR_SHOWS.filter(
      (s) => rows[s.id].letter && /^\d{5}$/.test(rows[s.id].digits)
    ).map((s) => ({
      date,
      show: s.id,
      letter: rows[s.id].letter,
      digits: rows[s.id].digits,
    }));
    if (!items.length) {
      toast.error('Letter + 5 digits full-a fill பண்ணுங்க');
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/api/results/bulk`, { items }, { headers: authHeaders() });
      toast.success(`${date.split('-').reverse().join('.')} — ${items.length} results save ஆயிடுச்சு`);
    } catch {
      toast.error('Save failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-8 border border-white/10 bg-black/30 p-5" data-testid="gr-backdate-control">
      <div className="mb-3 flex items-center gap-2">
        <CalendarClock className="h-4 w-4 text-[#F5C542]" />
        <h2 className="font-display text-sm uppercase tracking-[0.2em] text-[#F5C542]">
          Golden Raja — Back Date Results
        </h2>
      </div>
      <div className="mb-4 flex flex-wrap items-center gap-2">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#A3A3A3]">Date:</p>
        <input
          type="date"
          value={date}
          max={istYesterday()}
          onChange={(e) => setDate(e.target.value)}
          data-testid="gr-backdate-date"
          className="border border-white/15 bg-black/60 px-3 py-2 text-sm text-white outline-none focus:border-[#F5C542]"
        />
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {GR_SHOWS.map((s) => (
          <div key={s.id} className="border border-white/10 p-3">
            <p className="mb-2 text-[10px] uppercase tracking-[0.2em] text-[#A3A3A3]">{s.label}</p>
            <div className="flex gap-2">
              <select
                value={rows[s.id].letter}
                onChange={(e) => set(s.id, 'letter', e.target.value)}
                data-testid={`gr-backdate-letter-${s.id}`}
                className="border border-white/15 bg-black/60 px-2 py-2 text-sm text-white outline-none focus:border-[#F5C542]"
              >
                <option value="">–</option>
                {LETTERS.map((l) => (
                  <option key={l} value={l}>{l}</option>
                ))}
              </select>
              <input
                type="text"
                inputMode="numeric"
                maxLength={5}
                value={rows[s.id].digits}
                onChange={(e) => set(s.id, 'digits', e.target.value.replace(/\D/g, ''))}
                placeholder="12345"
                data-testid={`gr-backdate-digits-${s.id}`}
                className="w-full border border-white/15 bg-black/60 px-3 py-2 text-sm tracking-[0.2em] text-white outline-none focus:border-[#F5C542]"
              />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4">
        <button
          type="button"
          onClick={save}
          disabled={busy}
          data-testid="gr-backdate-save-btn"
          className="bg-[#F5C542] px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.2em] text-black hover:bg-[#FFDD75] disabled:opacity-50"
        >
          Save Back Date Results
        </button>
      </div>
      <p className="mt-2 text-[11px] text-[#666]">
        Pazhaya date results miss ஆனா / thappa போனா இங்க add அல்லது fix பண்ணுங்க — chart-la உடனே update ஆகும். Live stage-a இது disturb பண்ணாது. இன்றைய results-க்கு மேல இருக்கும் show cards-ஐயே use பண்ணுங்க.
      </p>
    </div>
  );
}
